import { ItemCard } from '../widget/ItemCard.js';
import { hasRealVariants } from './variantUtils.js';
import { VariationDesktopPicker } from './VariationDesktopPicker.js';

/**
 * ProductPicker - Overlay that displays search results as cards or a list.
 *
 * Layouts:
 *   "cards" — horizontal scrollable cards (2-4 products)
 *   "list"  — vertical compact list (5+ products)
 *
 * Options:
 *   onProductAdd(product) — fired when user clicks Add
 *   onClose()             — fired when user clicks X
 */
export class ProductPicker {
  constructor(options = {}) {
    this.primaryColor = options.primaryColor || '#7c3aed';
    this.onProductAdd = options.onProductAdd || (() => {});
    this.onAddDisabled = options.onAddDisabled || (() => false);
    this.onClose = options.onClose || (() => {});
    this.element = null;
  }

  show(products, title, layout) {
    this.hide();

    // Wrapper gives picker-relative positioning context
    const wrapper = document.createElement('div');
    wrapper.className = 'picker-relative';

    const container = document.createElement('div');
    container.className = 'ttp-product-picker';
    container.setAttribute('data-layout', layout);

    const header = document.createElement('div');
    header.className = 'ttp-picker-header';
    header.innerHTML = `
      <span class="ttp-picker-title">${title}</span>
      <button class="ttp-picker-close">\u2715</button>
    `;
    header.querySelector('.ttp-picker-close').addEventListener('click', () => {
      this.hide();
      this.onClose();
    });
    container.appendChild(header);

    const productsEl = document.createElement('div');
    productsEl.className = layout === 'cards'
      ? 'ttp-products-horizontal'
      : 'ttp-products-vertical';

    const primaryColor = this.primaryColor;
    const onProductAdd = this.onProductAdd;
    const onAddDisabled = this.onAddDisabled;

    products.forEach(product => {
      const card = new ItemCard(product, {
        compact: layout === 'list',
        primaryColor,
        onAdd: (cardEl, p) => onProductAdd(cardEl, p),
        onAddDisabled: () => onAddDisabled(),
        hasVariants: hasRealVariants,
        onVariantPick: (cardEl, prod) => {
          const pickerRelative = cardEl.closest('.picker-relative');
          if (!pickerRelative) return;

          const productList = pickerRelative.querySelector('.ttp-product-picker');
          if (productList) productList.style.setProperty('display', 'none', 'important');

          const existing = pickerRelative.querySelector('.ttp-var-picker');
          if (existing) existing.remove();

          const picker = new VariationDesktopPicker({
            primaryColor: primaryColor || '#7c3aed',
            onProductAdd: (pickerEl, productData) => {
              onProductAdd(pickerEl, productData);
            },
            onBack: () => {
              pickerRelative.classList.remove('ttp-var-picker-active');
              if (productList) productList.style.removeProperty('display');
            },
          });

          pickerRelative.classList.add('ttp-var-picker-active');
          pickerRelative.appendChild(picker.render(prod));
        }
      });
      productsEl.appendChild(card.render());
    });

    container.appendChild(productsEl);
    wrapper.appendChild(container);
    this.element = wrapper;
    return wrapper;
  }

  hide() {
    if (this.element && this.element.parentNode) {
      this.element.parentNode.removeChild(this.element);
    }
    this.element = null;
  }
}
